/**
 * @generated SignedSource<<549c5fe9db8cc8792ad44e38ddd63126>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EntityWithPositionInput = {
  id: string;
  position?: number | null;
};
export type ServiceGroupEditServicesSortMutation$variables = {
  positions: ReadonlyArray<EntityWithPositionInput>;
};
export type ServiceGroupEditServicesSortMutation$data = {
  readonly updateServicePositions: boolean;
};
export type ServiceGroupEditServicesSortMutation = {
  response: ServiceGroupEditServicesSortMutation$data;
  variables: ServiceGroupEditServicesSortMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "positions"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "positions",
        "variableName": "positions"
      }
    ],
    "kind": "ScalarField",
    "name": "updateServicePositions",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ServiceGroupEditServicesSortMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServiceGroupEditServicesSortMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d2e38ed9817a419c35ee944a9a0bc56f",
    "id": null,
    "metadata": {},
    "name": "ServiceGroupEditServicesSortMutation",
    "operationKind": "mutation",
    "text": "mutation ServiceGroupEditServicesSortMutation(\n  $positions: [EntityWithPositionInput!]!\n) {\n  updateServicePositions(positions: $positions)\n}\n"
  }
};
})();

(node as any).hash = "cdafc0fa784f778ce60672a8011b5cf4";

export default node;
